import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Zoom from "@mui/material/Zoom";
import Typography from "@mui/material/Typography";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight as iconArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { faSignal as iconSignal } from "@fortawesome/pro-duotone-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";

import AboutIndex from "components/about/AboutIndex";
import imageHeroSignal from "assets/heros/map-signal-main.png";
import { scrollSnapTop } from "services/tools";

import configEntzy from "components/config/ConfigEntzy";
import { ModuleSubHeaderTag } from "components/utils/common/CommonTags";
import BadgeGooglePlay from "assets/badges/google-play.png";
import BadgeAppleStore from "assets/badges/apple-store.svg";

import "./HomeLanding.css";

function HomeLandingSummer2026(props) {
  const [showAbout, setShowAbout] = useState(false);

  const handleConnect = () => {
    props.drawerConnectToggle();
  };

  const handleToggleAbout = () => {
    scrollSnapTop();
    setShowAbout(!showAbout);
  };

  if (showAbout) {
    return (
      <Box className="home-exp home-exp-about">
        <Zoom in={showAbout}>
          <Container maxWidth="md" disableGutters>
            <Box className="home-exp-close" onClick={handleToggleAbout}>
              <FontAwesomeIcon icon={iconClose} size="2x" />
            </Box>
            <AboutIndex {...props} viewVariant="cards" />
          </Container>
        </Zoom>
      </Box>
    );
  }

  return (
    <Box className="home-exp home-exp-summer">
      <Box
        className="home-exp-hero"
        sx={{
          "--home-exp-hero-image": `url(${imageHeroSignal})`,
        }}
      >
        <Container maxWidth="lg" className="home-exp-heroInner">
          <Box className="home-exp-kicker">
            <FontAwesomeIcon icon={iconSignal} />
            <span>Entzy Summer 2026</span>
          </Box>
          <Typography variant="h1" className="home-exp-title">
            Find your people
          </Typography>
          <Typography variant="h5" className="home-exp-subtitle">
            Put your signal up. Eventuate a new kind of summer this year with
            simple, spontaneous, local, repeat meets.
          </Typography>
          <Stack
            className="home-exp-actions"
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
          >
            <Button
              variant="contained"
              size="large"
              className="home-exp-primary"
              onClick={handleConnect}
              endIcon={<FontAwesomeIcon icon={iconArrowRight} />}
            >
              Connect
            </Button>
            <Button
              variant="outlined"
              size="large"
              className="home-exp-secondary"
              onClick={handleToggleAbout}
            >
              How it works
            </Button>
          </Stack>
        </Container>
      </Box>
      <Box
        className="box-default footer-height text-center"
        sx={{
          mt: configEntzy.APP_SPACING_HL,
        }}
      >
        <ModuleSubHeaderTag text="Get the App" />
        <Box className="box-inline">
          <Box
            className="box-default half-width"
            sx={{ p: configEntzy.APP_SPACING_SM }}
          >
            <a
              href={
                "https://apps.apple.com/us/app/entzy/id1543725422?ct=" +
                configEntzy.APP_DOMAIN
              }
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <img
                alt="Download on the App Store"
                src={BadgeAppleStore}
                className="app-badge-apple"
              />
            </a>
          </Box>
          <Box
            className="box-default half-width"
            sx={{ p: configEntzy.APP_SPACING_SM }}
          >
            <a
              href={
                "https://play.google.com/store/apps/details?id=com.entzy.twa&utm_source=" +
                configEntzy.APP_DOMAIN
              }
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <img
                alt="Get it on Google Play"
                src={BadgeGooglePlay}
                className="app-badge-google"
              />
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default HomeLandingSummer2026;
